<app-organization-sidebar-layout>
  <app-page-header>
    <div class="flex flex-col gap-2.5">
      <div class="flex gap-3 items-center">
        <ui-button
          [iconOnly]="true"
          mode="outlined"
          class="flex-none"
          [routerLink]="['/organizations', organizationId(), 'analysis']"
          data-track="consumption-back-button"
        >
          <ng-icon name="heroArrowLeft" size="20" class="!block" />
        </ui-button>
        <app-page-title class="flex-1">
          {{ 'cockpit.analysis.consumption.title' | transloco }}
        </app-page-title>
      </div>
      <ui-breadcrumb-nav
        [ariaLabel]="'cockpit.analysis.consumption.page.breadcrumbAriaLabel' | transloco"
      >
        <ui-breadcrumb>
          <a [routerLink]="['/organizations', organizationId()]">
            <ng-icon name="heroHome" size="20" class="!block" />
            <span class="sr-only">{{
              'cockpit.analysis.consumption.page.breadcrumbHome' | transloco
            }}</span>
          </a>
        </ui-breadcrumb>
        <ui-breadcrumb>
          <a [routerLink]="['/organizations', organizationId(), 'analysis']">
            {{ 'cockpit.analysis.consumption.page.breadcrumbAnalysis' | transloco }}
          </a>
        </ui-breadcrumb>
        <ui-breadcrumb>
          <a
            [routerLink]="['/organizations', organizationId(), 'analysis', 'consumption']"
            aria-current="page"
          >
            {{ 'cockpit.analysis.consumption.page.breadcrumbConsumption' | transloco }}
          </a>
        </ui-breadcrumb>
      </ui-breadcrumb-nav>
    </div>
  </app-page-header>

  <div class="flex flex-col gap-5">
    <app-analysis-consumption-filters
      [filter]="filter()"
      [locationsLoading]="locations.isLoading()"
      [locations]="locations.hasValue() ? locations.value().items : []"
      [energyInterfacesLoading]="energyInterfaces.isLoading()"
      [energyInterfaces]="energyInterfaces.hasValue() ? energyInterfaces.value().items : []"
      (changeFilter)="onChangeConsumptionFilter($event)"
    />

    <app-analysis-consumption-graph-card
      [filter]="filter()"
      [state]="data()"
      [organizationId]="organizationId()"
      (changeDate)="onChangeDate($event)"
      (changeGranularity)="onChangeGranularity($event)"
      (clickReload)="onClickReload()"
    />

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <app-analysis-consumption-details-kpi-card [filter]="filter()" [state]="data()" />
      <app-analysis-consumption-details-peakload-kpi-card [filter]="filter()" [state]="data()" />
    </div>
  </div>
</app-organization-sidebar-layout>
